var receiptMap = {
  id: 'id',
  userId: 'userId',
  transactionId: 'from',
  files: 'files',
  dateCreated: 'dateCreated'
};
export default receiptMap;